// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:768px) and (max-width:1024px){.carousel__viewport{border-radius:0!important}}@media only screen and (max-width:767px){.hero_banner .carousel__viewport{border-radius:0!important}.hero_banner .black-bottom-pagination-container{left:0!important}}.hero_banner .black-bottom-pagination-container{left:3rem}", ""]);
// Exports
module.exports = exports;
